import React from 'react'
import { FormattedMessage } from 'react-intl';

const NoMakeupWarning = () => {
  return (
    <div className="md-text-medium text-center my-2">
      <FormattedMessage
        id="tabs.pls_select_makeup_category"
        defaultMessage="Please select a makeup category"
      />
    </div>
  )
}

export default NoMakeupWarning;
